import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { CommonService } from "../../_services/common.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FlashMessagesService } from "angular2-flash-messages";
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { ImageCropperComponent } from '../../shared/image-cropper/image-cropper.component';

export interface DialogData {
  assignStatus: string;
  item_type: string;
  artworkFiles: {};
  mockupDataFiles: {};
  mockupFileName: {},
  printLocation: string;
  printPosition: {};
  artFileInkcolor: {};
  inkChangeData: Array<any>,
  active_artwork_loc: string,
  selectedInkColorObj: Array<any>,
  productsData: Array<any>,
  otherPrintSettings: Array<any>,
  mockupMessageData: {},
  activeMockupData: {},
  userId: string,
  artMockupData: {},
  isPublicUrl: string,
  token: string,
  first_name: string,
  last_name: string,
  orderType: string,
  active_image_loc:string,
  lineItemArtworkData: any,
  lineItemMockupData: any,
}
@Component({
  selector: 'app-invoice-item',
  templateUrl: './invoice-item.component.html',
  styleUrls: ['./invoice-item.component.css']
})
export class InvoiceItemComponent implements OnInit {
  public loading = false;
  public userDetails: any = {};
  public isOpenComments = {};
  public currentMessage = {};
  public currentPrintPos = {};
  public artFileColor = {};
  public isProcessing = { mockup_approval_notes: false, revision: false };
  imageData: any;
  public mockup_upload_error = null;
  public selectedFile = null;
  public ProjectData: any = {};
  public imageUrl: string;
  public uploadUrl: string;
  private cx: CanvasRenderingContext2D;
  private invoiceId: string;
  //public allPosition:any=[];
  public invoiceFiles: Array<any> = [];
  public previousArtworkFiles: Array<any> = [];
  public isArtworkFilesPresent: Array<any> = [];
  public prevFileType: string;
  public prevFileName: string;
  public isShowAssign = false;
  @ViewChild("canvas") canvas;
  private artFileName: string;
  public imp_upload_error = null;
  public artworkSrc = null;
  public selectedArtFile = null;
  private artfiledata = {};
  public onImagePreview = false;
  msg: string;
  private selectedMockupFile = null;
  private selectedMockupSpecFile = null;
  private selectedFileName: SafeUrl | string = null;
  private callMockAPI: number = 0;
  public artData:any = ''; 
  public artLineItem:any = ''; 

  constructor(
    public dialogRef: MatDialogRef<InvoiceItemComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private CommonService: CommonService,
    private _flashMessagesService: FlashMessagesService,
    private router: Router,
    private CommonProjectDataService: CommonProjectDataService,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.userDetails = JSON.parse(localStorage.getItem("userDetails"));
    this.activeLocationData();
    if (this.data.printLocation && this.data.isPublicUrl != 'Yes')
      this.showArtworkFile();

    //this.allPosition=Object.keys(this.data.mockupMessageData['mockups']);
    if (this.data.lineItemArtworkData) {
      this.artData = this.data.lineItemArtworkData;
    }

    if (this.data.lineItemMockupData) {
      this.artData = this.data.lineItemMockupData;
    }

    if (this.artData) {
      this.artLineItem = this.artData.projects.projects_data[this.artData.projectKey].section_items[this.artData.sectionKey].custom_items[this.artData.customItemKey];
    }
  }
  trackByFn(index: any, item: any) {
    return index;
  }

  activeLocationData() {
    if (this.data.activeMockupData) {
      this.currentMessage[this.data.activeMockupData['printLocs']] = {
        revision: '',
        mockup_approval_notes: ''
      };
    }
  }

  generateCol = function (quantityArr) {
    let largeNumber = quantityArr.reduce(
      (max, p) => (p > max ? p : max),
      quantityArr[0]
    );
    return this.numToArr(largeNumber);
  }

  numToArr = function (inputNum) {
    return new Array(inputNum);
  };

  onNoClick(): void {
    this.dialogRef.close(this.msg);
    if (this.invoiceId) {
      // this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
      //   this.router.navigate(["/invoices/" + this.invoiceId]));
    }
  }

  sendReply = function (msgType) {
    this.isProcessing[msgType] = true;
    this.loading = true;
    let pKey = this.data.activeMockupData.projectKey;
    let projectKey = this.data.activeMockupData.projectKey + 1;
    let printLocs = this.data.activeMockupData.printLocs;
    let msgKey = (msgType == 'invoice') ? 'comments' : (msgType == 'revision') ? 'revisions' : 'mockup_approval_notes';
    let apiMethod = (msgType == 'revision') ? 'mockup/revision' : 'mockup/approved';
    let messageOptions = {
      id: this.data.isPublicUrl == 'Yes' ? this.data.userId : localStorage.getItem("userID"),
      invoice_id: this.data.activeMockupData.invoiceId,
      project: projectKey,
      location: printLocs,
      message: this.currentMessage[printLocs][msgType]
    }    

    if (this.currentMessage[printLocs][msgType]) {
      this.CommonService.apiService(
        "POST",
        apiMethod,
        messageOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          this.isProcessing[msgType] = false;
          if (response.status === true) {
            if (msgType == 'mockup_approval_notes') {
              if (this.data.mockupMessageData.messages && this.data.mockupMessageData.messages[printLocs]) {
                this.data.mockupMessageData.messages[printLocs][msgKey] = {
                  message: this.currentMessage[printLocs][msgType],
                  first_name: this.data.isPublicUrl == 'Yes' ? this.data.first_name : this.userDetails.first_name,
                  last_name: this.data.isPublicUrl == 'Yes' ? this.data.last_name : this.userDetails.last_name,
                  created_at: new Date(),
                  type: this.data.isPublicUrl == 'Yes' ? 'User' : this.userDetails.type,
                  profile_img: this.userDetails.type != 'User' ? this.userDetails.profile_img : null
                };
               

              }
              else {
                Object.assign(this.data.mockupMessageData, {
                  messages: {
                    [printLocs]: {
                      [msgKey]: [{
                        message: this.currentMessage[printLocs][msgType],
                        first_name: this.data.isPublicUrl == 'Yes' ? this.data.first_name : this.userDetails.first_name,
                        last_name: this.data.isPublicUrl == 'Yes' ? this.data.last_name : this.userDetails.last_name,
                        created_at: new Date(),
                        type: this.data.isPublicUrl == 'Yes' ? 'User' : this.userDetails.type,
                        profile_img: this.userDetails.type != 'User' ? this.userDetails.profile_img : null
                      }]
                    }
                  }
                });               

              }
            }
            else {
              if (this.data.mockupMessageData.messages && this.data.mockupMessageData.messages[printLocs] && this.data.mockupMessageData.messages[printLocs][msgKey]) {
                this.data.mockupMessageData.messages[printLocs][msgKey].unshift({
                  message: this.currentMessage[printLocs][msgType],
                  first_name: this.data.isPublicUrl == 'Yes' ? this.data.first_name : this.userDetails.first_name,
                  last_name: this.data.isPublicUrl == 'Yes' ? this.data.last_name : this.userDetails.last_name,
                  created_at: new Date(),
                  type: this.data.isPublicUrl == 'Yes' ? 'User' : this.userDetails.type,
                  profile_img: this.userDetails.type != 'User' ? this.userDetails.profile_img : null

                });

              }
              else {
                if (this.data.mockupMessageData.messages && this.data.mockupMessageData.messages[printLocs]) {
                  Object.assign(this.data.mockupMessageData.messages[printLocs], {

                    [msgKey]: [{
                      message: this.currentMessage[printLocs][msgType],
                      first_name: this.data.isPublicUrl == 'Yes' ? this.data.first_name : this.userDetails.first_name,
                      last_name: this.data.isPublicUrl == 'Yes' ? this.data.last_name : this.userDetails.last_name,
                      created_at: new Date(),
                      type: this.data.isPublicUrl == 'Yes' ? 'User' : this.userDetails.type,
                      profile_img: this.userDetails.type != 'User' ? this.userDetails.profile_img : null
                    }]

                  });

                }
                else if (this.data.mockupMessageData.messages) {
                  Object.assign(this.data.mockupMessageData.messages, {
                    [printLocs]: {
                      [msgKey]: [{
                        message: this.currentMessage[printLocs][msgType],
                        first_name: this.data.isPublicUrl == 'Yes' ? this.data.first_name : this.userDetails.first_name,
                        last_name: this.data.isPublicUrl == 'Yes' ? this.data.last_name : this.userDetails.last_name,
                        created_at: new Date(),
                        type: this.data.isPublicUrl == 'Yes' ? 'User' : this.userDetails.type,
                        profile_img: this.userDetails.type != 'User' ? this.userDetails.profile_img : null
                      }]
                    }

                  });


                }
                else if (!this.data.mockupMessageData.messages) {
                  Object.assign(this.data.mockupMessageData, {
                    messages: {
                      [printLocs]: {
                        [msgKey]: [{
                          message: this.currentMessage[printLocs][msgType],
                          first_name: this.data.isPublicUrl == 'Yes' ? this.data.first_name : this.userDetails.first_name,
                          last_name: this.data.isPublicUrl == 'Yes' ? this.data.last_name : this.userDetails.last_name,
                          created_at: new Date(),
                          type: this.data.isPublicUrl == 'Yes' ? 'User' : this.userDetails.type,
                          profile_img: this.userDetails.type != 'User' ? this.userDetails.profile_img : null
                        }]
                      }
                    }
                  });
                }

              }
            }
            this.currentMessage[this.data.activeMockupData['printLocs']][msgType] = '';
            // if (msgType == 'mockup_approval_notes')
            // {                    
            //   let activeIndex = this.data.mockupMessageData['active_location_arr'].indexOf(printLocs);
            //   if (this.data.mockupMessageData['active_location_arr'].length > activeIndex + 1) {
            //     this.data.activeMockupData.printLocs = this.data.mockupMessageData['active_location_arr'][activeIndex + 1]
            //     this.activeLocationData();               
            //   }           

            // }


          }
          if (msgKey != 'comments' && msgKey != 'revisions') {
            this.msg = "success";
            let activeIndex = this.data.mockupMessageData['active_location_arr'].findIndex(x => x.emblocation_id == printLocs);
            if (this.data.mockupMessageData['active_location_arr'].length > activeIndex + 1) {
              this.data.activeMockupData.printLocs = this.data.mockupMessageData['active_location_arr'][activeIndex + 1].emblocation_id;
              this.activeLocationData();

            }
            else {
              this.dialogRef.close(this.msg);

            }
            // if (this.data.isPublicUrl != 'Yes') {
            //   this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
            //     this.router.navigate(["/invoices/" + this.data.activeMockupData.invoiceId]));
            // }
            // else {
            //   this.router.navigateByUrl('/RefrshComponent', { skipLocationChange: true }).then(() =>
            //     this.router.navigate(["/invoice/" + this.data.token]));
            // }

          }
        },
        err => {
          this.loading = false;
          this.isProcessing[msgType] = false;
          console.log(err);
        }
      );

    }
  }

  downloadImage(imageUrl) {
    window.open(imageUrl, "_blank");
  }

  // displayCanvasImage(currentlocation)
  // {
  //   this.artFileColor=this.data.artFileInkcolor[currentlocation];
  //   this.currentPrintPos=this.data.printPosition[currentlocation];
  // }

  onLogoChangedUpload = function (selectedFileData: any, mockupupload: string) {
    this.loading = true;
    const apiName = mockupupload === 'mockup' ? 'upload/mockup' : mockupupload === 'vector' ? 'upload/vector' : '';
    const uploadMockup = new FormData();
    uploadMockup.append(mockupupload, selectedFileData.file, selectedFileData.name);
    uploadMockup.append('id', localStorage.getItem("userID"));
    uploadMockup.append('invoice_id', this.data.artMockupData.invoiceId);
    uploadMockup.append('location', selectedFileData.location);
    uploadMockup.append('project', this.data.artMockupData.projectKey);
    uploadMockup.append('order_type', this.data.orderType);

    this.CommonService.apiService(
      "POST",
      apiName,
      uploadMockup
    ).subscribe((response: any) => {
      
      if (response.status === true) {
        this.msg = "success";
        let doneAPIMockup = false;
        this.callMockAPI += 1;
        this.invoiceId = this.data.artMockupData.invoiceId;
        if (this.selectedMockupFile && this.selectedMockupSpecFile) {
          if (this.callMockAPI >= 2) {
            doneAPIMockup = true;
          }
        } else {
          if (this.callMockAPI == 1) {
            doneAPIMockup = true;
          }
        }

        if (doneAPIMockup) {
          this.onNoClick();
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
      window.scrollTo(0, 0);
    },(err) => {
      this.callMockAPI += 1;
      this.loading = false;
      this._flashMessagesService.show(err.error.message, { cssClass: 'alert-warning', timeout: 3000 });
    })
  }

  getInvoiceList = function () {

    this.invoiceOptions = {
      id: localStorage.getItem("userID"),
      order_id: this.data.artMockupData.invoiceId
    };
    this.CommonService.apiService(
      "POST",
      "order",
      this.invoiceOptions
    ).subscribe(
      (response: any) => {

        if (response.status === true) {
          if (response.data) {
            let obj = JSON.parse(JSON.stringify(response));
            this.data.mockupDataFiles = obj.data.projects_data[this.data.artMockupData.projectKey - 1].mockups[this.data.printLocation];
          }
        }
      },
      err => {
        console.log(err);
      }
    );
  }

  showInvoiceArtwork(imgName) {
    let imgExt = imgName.split(".").pop().toLowerCase();
    if (['ai', 'eps', 'pdf', 'tiff', 'tif', 'zip', 'cdr', 'ps', 'psd'].indexOf(imgExt) !== -1) {
      return imgName = 'assets/img/' + imgExt + '.png';
    }
    else {
      return imgName;
    }

  }

  showInvoiceArtworkSelection(file) {
    let imgExt = file.name.split(".").pop().toLowerCase();
    if (['ai', 'eps', 'pdf', 'tiff', 'tif', 'zip', 'cdr', 'ps', 'psd'].indexOf(imgExt) !== -1) {
      return 'assets/img/' + imgExt + '.png';
    }
    else {
      return file.path;
    }

  }

  displayCanvasImage(url, artFileType, location, index, orignalFileName) {
    this.isShowAssign = false;
    this.uploadUrl = url;
    this.imageUrl = environment.API_URL + '/file/download/' + btoa(url) + '/' + btoa(orignalFileName ? orignalFileName : '');
    let urlExt = url.split(".").pop().toLowerCase();
    if (['ai', 'eps', 'pdf', 'tiff', 'tif', 'zip', 'cdr', 'ps', 'psd'].indexOf(urlExt) !== -1) {
      url = 'assets/img/' + urlExt + '.png';
    }
    else {
      url
    }
    if (artFileType == 'artfile') {
      this.artFileColor = this.data.artFileInkcolor;
      this.currentPrintPos = this.data.printPosition;
    }
    else {
      this.artFileColor = {};
      this.currentPrintPos = {};
    }
    const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
    this.cx = canvasEl.getContext('2d');
    let image = new Image();
    image.src = url;
    canvasEl.width = 500;
    canvasEl.height = 480;
    let imageAspectRatio = image.width / image.height;
    let canvasAspectRatio = canvasEl.width / canvasEl.height;
    let renderableHeight = image.height;
    let renderableWidth = image.width;
    let xStart = (canvasEl.width - image.width) * 0.5;
    let yStart = (canvasEl.height - image.height) * 0.5;

    // If image's aspect ratio is greater than canvas's we fit on width
    // and place the image centrally along height

    if (image.width >= canvasEl.width) {
      renderableWidth = canvasEl.width - 50;
      renderableHeight = image.height * (renderableWidth / image.width);
      xStart = (canvasEl.width - renderableWidth) / 2;
      yStart = (canvasEl.height - renderableHeight) / 2;
    }
    if (image.height > canvasEl.height) {
      renderableHeight = canvasEl.height;
      renderableWidth = image.width * (renderableHeight / image.height);
      xStart = (canvasEl.width - renderableWidth) / 2;
      yStart = 0;
    }
    this.cx.drawImage(image, xStart, yStart, renderableWidth, renderableHeight);
    if (location != "") {
      this.prevFileType = this.previousArtworkFiles[location][index].type;
      this.prevFileName = this.previousArtworkFiles[location][index].original_file_name == null ? '' : this.previousArtworkFiles[location][index].original_file_name;

      //this.artFileColor = this.previousArtworkFiles[location][index].colors;
      if (this.prevFileType == 'mockup' || this.prevFileType == 'vector') {
        this.isShowAssign = true;
      }
    }
  }

  showMessage() {
    this._flashMessagesService.show("Please Select uploaded file for download", { cssClass: 'alert-danger', timeout: 3000 });
  }

  showArtworkFile = function () {
    this.clientOptions = {
      id: localStorage.getItem("userID"),
      user_id: this.data.userId
    };
    this.CommonService.apiService(
      "POST",
      "invoices/files",
      this.clientOptions
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.invoiceFiles = response.data;
          let index = this.invoiceFiles.findIndex(x => x.invoice_id == this.data.artMockupData.invoiceId);
          this.invoiceFiles.splice(index, 1);
        }
      },
      err => {
        console.log(err);
      }
    );
  }
  backToArtworkData() {
    this.isArtworkFilesPresent = [];
    this.previousArtworkFiles = [];
    //this.displayCanvasImage("", 0, "");
  }

  displayFolderData(artWorkFiles) {
    this.previousArtworkFiles = artWorkFiles;
    this.isArtworkFilesPresent = Object.keys(artWorkFiles);

  }

  assignMockupSpec = function () {
    let apiName;
    if (this.prevFileType == 'mockup') {
      apiName = 'assign/mockup';
    }
    if (this.prevFileType == 'vector') {
      apiName = 'assign/vector';
    }

    this.loading = true;
    const assignMockup = new FormData();
    assignMockup.append('file_url', this.uploadUrl);
    assignMockup.append('file_name', this.prevFileName);
    assignMockup.append('id', localStorage.getItem("userID"));
    assignMockup.append('invoice_id', this.data.artMockupData.invoiceId);
    assignMockup.append('location', this.data.printLocation);
    assignMockup.append('project', this.data.artMockupData.projectKey);

    this.CommonService.apiService(
      "POST",
      apiName,
      assignMockup
    ).subscribe((response: any) => {
      this.loading = false;
      if (response.status === true) {
        if (this.prevFileType == 'mockup') {
          Object.assign(this.data.mockupFileName, { mockup: this.prevFileName });
        }
        if (this.prevFileType == 'vector') {
          Object.assign(this.data.mockupFileName, { vector: this.prevFileName });
        }
        this._flashMessagesService.show(response.message, { cssClass: 'alert-success', timeout: 2000 });
        this.getInvoiceList();
        this.invoiceId = this.data.artMockupData.invoiceId;
      }
      window.scrollTo(0, 0);
    },
      (err) => {
        this.loading = false;
        this._flashMessagesService.show(err.error.message, { cssClass: 'alert-warning', timeout: 3000 });
      })


  }

  onFileChanged(element) {
    this.onImagePreview = false;
    var reader = new FileReader();
    var img = new Image();
    var imgTypeArr = [
      "image/jpeg",
      "image/jpg",
      "image/gif",
      "image/bmp",
      "image/png"
    ];
    reader.onload = (event: any) => {
      this.imp_upload_error = null;
      this.selectedArtFile = element.target.files[0];


      if (element.target.files[0].size > 524288000) {
        this.imp_upload_error = "File too large. File must be less than 500 megabytes.";
      }

      var validFileTypeArr = [
        "image/jpeg",
        "image/jpg",
        "image/gif",
        "image/bmp",
        "image/png",
        "application/illustrator",
        "image/x-eps",
        "application/postscript",
        "image/x-photoshop",
        "image/vnd.adobe.photoshop",
        "image/tiff",
        "image/svg+xml",
        "application/pdf"
      ];


      if (validFileTypeArr.indexOf(element.target.files[0].type) < 0) {
        this.imp_upload_error = "Invalid file type. Only JPG, GIF, BMP, PNG, AI, EPS, PDF, PSD, SVG, TIF types are accepted.";
      }
      if (imgTypeArr.indexOf(element.target.files[0].type) >= 0) {
        //img.src = this.src;       
        this.onImagePreview = true;
      }
      else {
        this.onImagePreview = false;
      }
      if (this.imp_upload_error != null) {
        this._flashMessagesService.show(this.imp_upload_error, { cssClass: 'alert-warning', timeout: 5000 });
      }
      else {
        this.artworkSrc = event.target.result;
      }

    };
    if (element) {
      reader.readAsDataURL(element.target.files[0]);
    }
  }

  saveArtFile = function () {
    this.loading = true;
    //this.isArtworkLoaded = false;
    let active_uui = this.CommonProjectDataService.getNewUid();
    let noOfColor = '4';
    const uploadedFileOption = new FormData();
    uploadedFileOption.append('id', localStorage.getItem("userID"));
    uploadedFileOption.append('img_name', this.selectedArtFile);
    uploadedFileOption.append('artwork_id', active_uui);
    uploadedFileOption.append('no_of_color', noOfColor);

    this.CommonService.apiService(
      "POST",
      "artwork/upload",
      uploadedFileOption
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          this.img_name = response.data.img_name;
          this.artwork_img = response.data.artwork_img;
          this.artfiledata = {
            'active_uui': active_uui,
            'artwork_img': response.data.artwork_img,
            'org_file': response.data.img_name,
            'img_ext_path': response.data.img_ext_path
          }
          if (response.data.org_file && response.data.org_file_ext_path) {
            this.artfiledata.org_file = response.data.org_file;
            this.artfiledata.org_file_ext_path = response.data.org_file_ext_path;
            this.artfiledata.org_file_type = response.data.org_file_type;
          }
          this.dialogRef.close(this.artfiledata);
          // if (!this.data.artworkHexColors[this.data.active_artwork_loc]) {
          //   this.data.artworkHexColors[this.data.active_artwork_loc] = {
          //     'active_uui': this.active_uui,
          //     'artwork_img': response.data.artwork_img,
          //     'org_file': response.data.img_name,
          //     'img_ext_path': response.data.img_ext_path
          //   }
          // }
          // else {
          //   this.data.artworkHexColors[this.data.active_artwork_loc]['active_uui'] = this.active_uui;
          //   this.data.artworkHexColors[this.data.active_artwork_loc]['artwork_img'] = response.data.artwork_img;
          //   this.data.artworkHexColors[this.data.active_artwork_loc]['org_file'] = response.data.img_name;
          //   this.data.artworkHexColors[this.data.active_artwork_loc]['img_ext_path'] = response.data.img_ext_path;
          // }

          // if (response.data.org_file && response.data.org_file_ext_path) {
          //   this.data.artworkHexColors[this.data.active_artwork_loc].org_file = response.data.org_file;
          //   this.data.artworkHexColors[this.data.active_artwork_loc].org_file_ext_path = response.data.org_file_ext_path;
          //   this.data.artworkHexColors[this.data.active_artwork_loc].org_file_type = response.data.org_file_type;
          // }
          // this.data.activeStep = "steptwo";
          // if (this.data.activeStep == "steptwo") {
          //   //this.dialogRef.close();  

          //   this.dialogRef.close({ activeStep: this.data.activeStep, url: this.data.artworkHexColors[this.data.active_artwork_loc]['img_ext_path'], artwork_img: this.artwork_img });
          //   //this.callArtfileStepTwo();       
          //   //this.displayCanvasImage(this.data.artworkHexColors[this.data.active_artwork_loc]['img_ext_path'], 'artfile', this.data.active_artwork_loc, 0);
          // }

        }
      },
      err => {
        this.loading = false;
        console.log("error msg", err.error.message);
      }
    );


  }

  openImageCropperDialog(event, maintainAspectRatio, aspectRatio, resizeToWidth, resizeToHeight, section, location): void {
    if(event.target.files[0] && event.target.files[0].name) {
      const dialogRef = this.dialog.open(ImageCropperComponent, {
        width: "500px",
        disableClose: true,
        data: {
          event: event,
          maintainAspectRatio: maintainAspectRatio,
          aspectRatio: aspectRatio,
          resizeToWidth: resizeToWidth,
          resizeToHeight: resizeToHeight
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result.status) {
          if (section == 'mockup') {
            this.selectedMockupFile = {
              file: result.file,
              name: result.fileName,
              path: result.base64,
              location: location
            };
          }
        }
      });
    }
  }

  onLogoChanged = function (event, location) {
    this.mockup_upload_error = null;
    this.selectedFile = event.target.files[0];
    let validFileTypeArr = [];
    let imgTypeArr = [];
    const eventTargetName = event.target.name;

    if (eventTargetName == 'upload_mockup') {
      imgTypeArr = [
        "image/jpeg",
        "image/jpg",
        "image/bmp",
        "image/png"
      ];
      if (this.selectedFile.size > 12582912) {
        this.mockup_upload_error = "File too large. File must be less than 12 megabytes.";
      }
      if (imgTypeArr.indexOf(this.selectedFile.type) < 0) {
        this.mockup_upload_error = "Invalid Mockup file type. Only JPG and PNG types are accepted.";
      }
    }

    if (eventTargetName == 'upload_mockup_spec') {
      validFileTypeArr = ["jpeg", "jpg", "png", "svg", "pdf", "psd", "ai", "eps", "ps", "cdr", "bmp", "tif", "tiff", "zip"];
      if (validFileTypeArr.indexOf(this.selectedFile.name.split(".").pop().toLowerCase()) < 0) {
        this.mockup_upload_error = "Invalid Spec file type. Only JPG,BMP, PNG, AI, EPS, PS, CDR, PDF, PSD,SVG,ZIP,TIF and TIFF types are accepted.";
      }
    }

    if (!this.mockup_upload_error) {
      let render = new FileReader();
      render.onload = (event: any) => {
        this.selectedFileName = this.sanitizer.bypassSecurityTrustUrl(event.target.result);
        if (eventTargetName == 'upload_mockup') {
          this.selectedMockupFile = {
            file: this.selectedFile,
            name: this.selectedFile.name,
            path: this.selectedFileName,
            location: location
          };
        }

        if (eventTargetName == 'upload_mockup_spec') {
          this.selectedMockupSpecFile = {
            file: this.selectedFile,
            name: this.selectedFile.name,
            path: this.selectedFileName,
            location: location
          };
        }
        
      }
      render.readAsDataURL(this.selectedFile);
    }
  }

  addMock() {
    const uploadMockupMethod = () => {
      if (this.selectedMockupFile && this.selectedMockupFile.file) {
        this.onLogoChangedUpload(this.selectedMockupFile, 'mockup');
      }
    };
  
    const uploadVectorMethod = () => {
      if (this.selectedMockupSpecFile && this.selectedMockupSpecFile.file) {
        this.onLogoChangedUpload(this.selectedMockupSpecFile, 'vector');
      }
    };
  
    if (this.selectedMockupFile && this.selectedMockupFile.file && this.selectedMockupSpecFile && this.selectedMockupSpecFile.file) {
      uploadMockupMethod();
      setTimeout(uploadVectorMethod, 2000);
    } else {
      uploadMockupMethod();
      uploadVectorMethod();
    }
  }

  addArtWorkForLineItem() {
    const uploadMockupMethod = () => {
      if (this.selectedMockupFile && this.selectedMockupFile.file) {
        this.uploadArtWorkForLineItem(this.selectedMockupFile, 'mockup');
      }
    };
  
    const uploadVectorMethod = () => {
      if (this.selectedMockupSpecFile && this.selectedMockupSpecFile.file) {
        this.uploadArtWorkForLineItem(this.selectedMockupSpecFile, 'vector');
      }
    };
  
    if (this.selectedMockupFile && this.selectedMockupFile.file && this.selectedMockupSpecFile && this.selectedMockupSpecFile.file) {
      uploadMockupMethod();
      setTimeout(uploadVectorMethod, 2000);
    } else {
      uploadMockupMethod();
      uploadVectorMethod();
    }
  }
  

  uploadArtWorkForLineItem = function (selectedFileData: any, mockupupload: string) {
    this.loading = true;
    const apiName = mockupupload === 'mockup' ? 'upload/line-item-mockup' : mockupupload === 'vector' ? 'upload/line-item-vector' : '';
    const uploadMockup = new FormData();
    uploadMockup.append(mockupupload, selectedFileData.file, selectedFileData.name);
    uploadMockup.append('id', localStorage.getItem("userID"));
    uploadMockup.append('invoice_id', this.data.lineItemArtworkData.invoiceId);
    uploadMockup.append('project', this.data.lineItemArtworkData.projectKey);
    uploadMockup.append('order_type', this.data.orderType);
    uploadMockup.append('sectionKey', this.data.lineItemArtworkData.sectionKey);
    uploadMockup.append('customItemKey', this.data.lineItemArtworkData.customItemKey);

    this.CommonService.apiService(
      "POST",
      apiName,
      uploadMockup
    ).subscribe((response: any) => {
      
      if (response.status === true) {
        this.msg = "success";
        let doneAPIMockup = false;
        this.callMockAPI += 1;
        this.invoiceId = this.data.lineItemArtworkData.invoiceId;
        if (this.selectedMockupFile && this.selectedMockupSpecFile) {
          if (this.callMockAPI >= 2) {
            doneAPIMockup = true;
          }
        } else {
          if (this.callMockAPI == 1) {
            doneAPIMockup = true;
          }
        }

        if (doneAPIMockup) {
          this.onNoClick();
          this.loading = false;
        }
      } else {
        this.loading = false;
      }
      window.scrollTo(0, 0);
    },(err) => {
      this.callMockAPI += 1;
      this.loading = false;
      this._flashMessagesService.show(err.error.message, { cssClass: 'alert-warning', timeout: 3000 });
    })
  }

  sendReplyForLineItem = function (msgType) {
    const message = this.currentMessage[msgType];
    if (message) {
      this.isProcessing[msgType] = true;
      this.loading = true;
      
      const id = this.data.isPublicUrl == 'Yes' ? this.data.userId : localStorage.getItem("userID");
      const invoiceId = this.artData.invoiceId;
      const orderType = this.artData.orderType;
      const projectKey = this.artData.projectKey;
      const sectionKey = this.artData.sectionKey;
      const customItemKey = this.artData.customItemKey;

      const msgKey = msgType == 'revision' ? 'revisions' : 'mockup_approval_notes';
      const apiMethod = (msgType == 'revision') ? 'line-item-mockup/revision' : 'line-item-mockup/approved';
      const messageOptions = {
        id: id,
        invoice_id: invoiceId,
        order_type: orderType,
        project: projectKey,
        sectionKey: sectionKey,
        customItemKey: customItemKey,
        message: message
      }
      this.CommonService.apiService(
        "POST",
        apiMethod,
        messageOptions
      ).subscribe(
        (response: any) => {
          this.loading = false;
          this.isProcessing[msgType] = false;
          if (response.status === true) {
            this.msg = 'success';
            const profileData = {
              message: this.currentMessage[msgType],
              first_name: this.data.isPublicUrl == 'Yes' ? this.data.first_name : this.userDetails.first_name,
              last_name: this.data.isPublicUrl == 'Yes' ? this.data.last_name : this.userDetails.last_name,
              created_at: new Date(),
              type: this.data.isPublicUrl == 'Yes' ? 'User' : this.userDetails.type
            };
            this.currentMessage[msgType] = '';
            if (msgType == 'mockup_approval_notes') {
              if (!this.artLineItem.messages) {
                this.artLineItem.messages = {};
              }
              this.artLineItem.messages[msgKey] = profileData;
            }
            else {
              if (!this.artLineItem.messages) {
                this.artLineItem.messages = {};
              }
              if (!this.artLineItem.messages[msgKey]) {
                this.artLineItem.messages[msgKey] = [];
              }
              this.artLineItem.messages[msgKey].push(profileData);
            }
          }
        },
        err => {
          this.loading = false;
          this.isProcessing[msgType] = false;
          console.log(err);
        }
      );

    }
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/invoice-item/invoice-item.component.ts